type ConsentState = 'granted' | 'denied' | null

let currentConsentState: ConsentState = null
const consentChangeListeners: Set<() => void> = new Set()
let originalUetq: typeof window.uetq | null = null

export function subscribeToConsentChanges(listener: () => void) {
  consentChangeListeners.add(listener)
  return () => consentChangeListeners.delete(listener)
}

function notifyListeners() {
  consentChangeListeners.forEach((listener) => listener())
}

export function isTrackingAllowed(): boolean {
  return currentConsentState !== 'denied'
}

export function getConsentState(): ConsentState {
  return currentConsentState
}

export function revokeAllConsent() {
  currentConsentState = 'denied'

  if (typeof window === 'undefined') return

  if (window.gtag) {
    window.gtag('consent', 'update', {
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      ad_storage: 'denied',
      analytics_storage: 'denied',
    })
  }

  if (window.fbq) {
    window.fbq('consent', 'revoke', {})
  }

  if (window.uetq && !originalUetq) {
    originalUetq = window.uetq
  }
  if (window.uetq) {
    window.uetq = {
      push: () => {},
    } as typeof window.uetq
  }

  notifyListeners()
}

export function grantAllConsent() {
  currentConsentState = 'granted'

  if (typeof window === 'undefined') return

  if (window.gtag) {
    window.gtag('consent', 'update', {
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted',
    })
  }

  if (window.fbq) {
    window.fbq('consent', 'grant', {})
  }

  if (originalUetq) {
    window.uetq = originalUetq
  }

  notifyListeners()
}
